// extracted by css-extract-rspack-plugin
export default {"cls1":"UserTaggingPingBodyStyles-cls1_8J_","cls2":"UserTaggingPingBodyStyles-cls2_sMG UserTaggingPingBodyStyles-cls1_8J_"};